/* eslint-disable react/no-unused-prop-types */
import React, { useState } from 'react';
import { Button, Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useField } from 'formik';
import PropTypes from 'prop-types';
import pick from 'lodash/pick';

import _e from 'common/localeUtil';
import ChangeBackgroundDialog from '../dialog/ChangeBackgroundDialog';

const useStyles = makeStyles(theme => ({
	wrapper: {
		overflow: 'hidden',
		position: 'relative',
		'&:hover': {
			'& .toolbar': {
				opacity: 1
			}
		}
	},
	previewButton: {
		padding: theme.spacing(0.5),
		fontSize: '0.8rem',
		background: `rgba(0, 0, 0, 0.75)`,
		color: theme.palette.background.paper,
		'&:hover': {
			background: `rgba(0, 0, 0, 1)`
		},
		marginRight: theme.spacing(1)
	},
	formTitle: {
		fontWeight: '600',
		fontSize: '0.9rem',
		paddingBottom: theme.spacing(0.5)
	},
	previewActionBarStyle: {
		position: 'absolute',
		display: 'flex',
		width: '100%',
		flexDirection: 'row',
		flex: 1,
		top: 0,
		left: 0,
		justifyContent: 'flex-end',
		height: 60,
		alignItems: 'center',
		transition: 'opacity 1s ease-out'
		// background: `rgba(0, 0, 0, 0.75)`
	},
	snippetImageStyle: ({ avatarSize }) => {
		const dim = avatarSize || (window.innerWidth / 4) * (3 / 4);
		return {
			margin: '0 auto',
			width: dim,
			height: dim,
			backgroundSize: 'cover',
			backgroundPosition: 'center'
		};
	}
}));

const ImageSelectorField = props => {
	const classes = useStyles(props);
	const [dialogVisible, setDialogVisible] = useState(false);
	// eslint-disable-next-line no-unused-vars
	const [field, _, actions] = useField(props);
	const { label, className, dialogTitle, onValueChanged, defaultImage } = props;
	const toggleDialogVisible = () => setDialogVisible(!dialogVisible);

	const onImageChanged = url => {
		actions.setValue(url);
		onValueChanged && onValueChanged(url);
	};
	const handleRemoveImg = () => {
		actions.setValue(null);
		onValueChanged && onValueChanged(null);
	};
	console.log('ImageSelectorField', {
		fieldName: field.name,
		fieldValue: field.value,
		defaultImage
	});
	const imgUrl =
		field.value ||
		defaultImage ||
		'https://goalsmapper-widget.s3-ap-southeast-1.amazonaws.com/default_blank_image.jpg';

	return (
		<Box className={`${className} snippet-img-wrapper`}>
			{label && (
				<Box
					display="flex"
					flexDirection="row"
					justifyContent="space-between"
					alignItems="center"
				>
					<div className={classes.formTitle}>{label}</div>
				</Box>
			)}

			<div className={classes.wrapper}>
				{imgUrl && (
					<div
						className={classes.snippetImageStyle}
						style={{
							backgroundImage: `url('${imgUrl}')`
						}}
					/>
				)}
				{imgUrl && (
					<div className={`${classes.previewActionBarStyle} toolbar`}>
						<Button
							variant="contained"
							classes={{ root: classes.previewButton }}
							onClick={toggleDialogVisible}
						>
							{_e('edit')}
						</Button>
						<Button
							variant="contained"
							classes={{ root: classes.previewButton }}
							onClick={handleRemoveImg}
						>
							{_e('remove')}
						</Button>
					</div>
				)}
			</div>
			{dialogVisible && (
				<ChangeBackgroundDialog
					title={dialogTitle}
					handleClose={toggleDialogVisible}
					open={dialogVisible}
					onImageChanged={onImageChanged}
					options={{
						colorChangeable: false,
						...pick(props, [
							'maxWidth',
							'maxHeight',
							'showImageEditor',
							'cropRatio',
							'unsplashChangeable',
							'expectedImageSizeMessage',
							'acceptFiles'
						])
					}}
				/>
			)}
		</Box>
	);
};

ImageSelectorField.propTypes = {
	label: PropTypes.string,
	className: PropTypes.string,
	dialogTitle: PropTypes.string,
	defaultImage: PropTypes.string,
	onValueChanged: PropTypes.func,
	avatarSize: PropTypes.number,
	imageSize: PropTypes.shape({
		width: PropTypes.number.isRequired,
		height: PropTypes.number.isRequired
	}),
	maxWidth: PropTypes.number,
	maxHeight: PropTypes.number,
	showImageEditor: PropTypes.bool,
	cropRatio: PropTypes.number
};

export default ImageSelectorField;
